import React, { useReducer, useContext } from 'react';
import barraprincipalReducer from './barraprincipalReducer';

import Swal from 'sweetalert2';
import clienteAxios from '../../config/axios';

import proyectoContext from '../../context/proyectos/proyectoContext';
import barraprincipalContext from './barraprincipalContext'


import { 
    OPCIONES_MENU,
    VER_CUENTAS,
    OBTENER_USUARIOS,
    ELIMINAR_USUARIO,
    REINICIAR_BPPL_STATE
} from '../../types';

const BarraPrincipalState = props => {

    const proyectosContext = useContext(proyectoContext);
    const { proyecto, proyectoActivo, verDetalles } = proyectosContext;

    // State inicial
    const initialState = {
        cuentas: [],
        vistamenu: '',
        vercuentas: false
    }

    // Dispatch para ejecutar las acciones
    const [ state, dispatch ] = useReducer(barraprincipalReducer, initialState);

    // Segun el onClick, cambiará la vista
    const cambiarComponente = (btn1, btn2, componente) => {
        const btnAdminCuentas = document.getElementById(btn1);
        const btnVerPerfil = document.getElementById(btn2);
        const clase = btnAdminCuentas.classList[0]
        
        btnAdminCuentas.classList.add('active');
        btnAdminCuentas.classList.remove('no-active');
        btnVerPerfil.classList.add('no-active');
        btnVerPerfil.classList.remove('active');
        
        vistaMenu(componente);
        
        if(clase === 'active') {
            btnAdminCuentas.classList.remove('active')
            btnAdminCuentas.classList.add('no-active')
            vistaMenu('');
        }
    }

    // Funcion que reinicia los botones
    const reiniciarBotones = (vercuentas) => {
        if(vercuentas){
            const btnCrearCuenta = document.getElementById('btn-crear-cuenta');
            const btnVerCuentas = document.getElementById('btn-ver-cuentas');
    
            btnVerCuentas.classList.remove('active');
            btnCrearCuenta.classList.add('active');
        }
    }

    // Funcion que cierra un proyecto si estaba abierto
    const cerrarProyecto = () => {
        if(proyecto) {
            const btnProyecto = document.getElementById(proyecto[0]._id);
            btnProyecto.classList.remove('active');
            proyectoActivo(false);
            verDetalles(false);
        }
        
        // limpiarTarea();
        // formularioDescripcion(false);
    }

    // ***************** //
    // Funciones Reducer //
    // ***************** //

    // Cambia nombre del state al componente que va
    const vistaMenu = nombreVista => {
        dispatch({
            type: OPCIONES_MENU,
            payload: nombreVista
        })
    }

    // Funcion cambia el state de vercuentas
    const verCuentas = status => {
        dispatch({
            type: VER_CUENTAS,
            payload: status
        })
    }

    // Obtener usuarios
    const obtenerUsuarios = async () => {
        try {
            const respuesta = await clienteAxios.get('/api/usuarios');
            
            dispatch({
                type: OBTENER_USUARIOS,
                payload: respuesta.data.usuarios
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                'Error',
                'Hubo un error en el servidor, intenta de nuevo',
                'error'
            );
        }
    }

    // Eliminar usuario
    const eliminarUsuario = async id => {
        try {
            await clienteAxios.delete(`/api/usuarios/${id}`);
            dispatch({
                type: ELIMINAR_USUARIO,
                payload: id
            });

            Swal.fire({
                title: '¡Eliminado!',
                text: 'La cuenta se eliminó correctamente.',
                icon: 'success',
                confirmButtonColor: '#2f3848'
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                'Error',
                'Hubo un error en el servidor, intenta de nuevo',
                'error'
            );
        }
    }

    const reiniciarBpplState = () => {
        dispatch({
            type: REINICIAR_BPPL_STATE
        })
    }

    return(
        <barraprincipalContext.Provider
            value={{
                cuentas: state.cuentas,
                vistamenu: state.vistamenu,
                vercuentas: state.vercuentas,
                cambiarComponente,
                reiniciarBotones,
                cerrarProyecto,
                vistaMenu,
                verCuentas,
                obtenerUsuarios,
                eliminarUsuario,
                reiniciarBpplState
            }}
        >
            {props.children}
        </barraprincipalContext.Provider>
    )
}

export default BarraPrincipalState;